export default {
  en() {
    return {
      orderDetails: 'Order Details',
      phone: 'Phone',
      eventName: 'Event',
      item: 'Item',
      quantity: 'Quantity',
      reservationName: 'Reservation Name',
      subtotal: 'Subtotal',
      processingFee: 'Processing Fee',
      currency: 'Currency',
      total: 'Total',
      roomType: 'Room Type',
    }
  },

  enGB() {
    return {
      orderDetails: 'Order Details',
      phone: 'Phone',
      eventName: 'Event',
      item: 'Item',
      quantity: 'Quantity',
      reservationName: 'Reservation Name',
      subtotal: 'Subtotal',
      processingFee: 'Processing Fee',
      currency: 'Currency',
      total: 'Total',
      roomType: 'Room Type'
    }
  },

  ar() {
    return {
      orderDetails: 'تفاصيل الطلب',
      phone: 'الرقم',
      eventName: 'الحدث',
      item: 'سلعة',
      quantity: 'الكمية',
      reservationName: 'Reservation Name',
      subtotal: 'المجموع',
      processingFee: 'رسوم المعالجة',
      currency: 'العملة',
      total: 'المجموع',
      roomType: 'Room Type'
    }
  },

  it() {
    return {
      orderDetails: 'Dettagli dell\'ordine',
      phone: 'Telefono',
      eventName: 'Evento',
      item: 'سلعة',
      quantity: 'Quantità',
      reservationName: 'Nome della prenotazione',
      subtotal: 'Totale parziale',
      processingFee: 'Spese di commissione',
      currency: 'Valuta',
      total: 'Totale',
      roomType: 'Tipo di stanza',
    }
  },

  fr() {
    return {
      orderDetails: 'Détails de la commande',
      phone: 'Téléphone',
      eventName: 'Évènement',
      item: 'Item',
      quantity: 'Quantité',
      reservationName: 'Réservation au nom de',
      subtotal: 'Sous-total',
      processingFee: 'Frais de traitement',
      currency: 'Devise',
      total: 'Total',
      roomType: 'Type de chambre',
    }
  },

  ja() {
    return {
      orderDetails: 'ご注文詳細',
      phone: '電話番号',
      eventName: 'イベント',
      item: '項目',
      quantity: '数量',
      reservationName: '予約名',
      subtotal: '小計',
      processingFee: '手数料',
      currency: '通貨',
      total: 'ご請求額',
      roomType: 'ルームタイプ',
    }
  },

  de() {
    return {
      orderDetails: 'Bestelldaten',
      phone: 'Telefon',
      eventName: 'Veranstaltung',
      item: 'Artikel',
      quantity: 'Anzahl',
      reservationName: 'Reservierungsname',
      subtotal: 'Zwischentotal',
      processingFee: 'Bearbeitungsgebühr',
      currency: 'Währung',
      total: 'Gesamtbetrag',
      roomType: 'Zimmertyp',
    }
  },

  esMX() {
    return {
      orderDetails: 'Detalles de la Orden',
      phone: 'Teléfono',
      eventName: 'Evento',
      item: 'Artículo',
      quantity: 'Cantidad',
      reservationName: 'Nombre para la Reservación',
      subtotal: 'Subtotal',
      processingFee: 'Tarifa de Procesamiento',
      currency: 'Moneda',
      total: 'Total',
      roomType: 'Tipo de Habitación',
    }
  },

  zhCN() {
    return {
      orderDetails: '订单详情',
      phone: '手机',
      eventName: '活动',
      item: '一项',
      quantity: '数量',
      reservationName: '预订名称',
      subtotal: '小计',
      processingFee: '处理费',
      currency: '货币',
      total: '总计',
      roomType: '房间类型',
    }
  },

  pl() {
    return {
      orderDetails: 'szczegóły zamówienia',
      phone: 'telefon',
      eventName: 'impreza',
      item: 'artykuł',
      quantity: 'lość',
      reservationName: 'Reservation Name',
      subtotal: 'suma',
      processingFee: 'opłata manipulacyjna',
      currency: 'waluta',
      total: 'ogółem',
      roomType: 'rodzaj pokoju'
    }
  }
}
